import consultRequestCreator from '../../consultRequestCreator';
import urlConstants from '../../../constants/urlConstants';

export function fetchSearchResults(q) {
  return consultRequestCreator
    .get(urlConstants.SEARCH, { params: { q } })
    .then(response => response.data.results);
}
